export default __webpack_public_path__ + "static/all-practice-areas-fed447e67d638badf9f7fe6358ed9fd7.jpg";